import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { Event } from '../../class/event';

@Injectable()
export class EventService extends WebService {

    public getEvent (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort) + ',-newnesses.created_at');
        } else {
            params.append('_sort', String('-id,-newnesses.created_at'));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('station.route.stations,station.employee,newnesses.user.employee,employee,done_by,created_by'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/events?${params}`, options);
    }

    public newEvent(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/events`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateEvent(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/events/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteEvent(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/events/${id}`, { headers: this.headers } );
    }

    public infoEvent(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();
        params.append('id', String(id));
        params.append('_sort', String('-newnesses.created_at'));
        params.append('_with', String('station,newnesses.user.employee,employee'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/events?${params}`,  options );
    }
}




// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/event/event.service.ts